import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

export default function Sidebar({ items = [], onSelect, selected, searchQuery, onSearch, renderItem, isOpen = true, onClose }) {
  const handleSelect = (item) => {
    onSelect?.(item);
    onClose?.();
  };

  return (
    <>
      {/* Mobile backdrop */}
      {isOpen && <div className="md:hidden fixed inset-0 bg-black bg-opacity-40 z-30" onClick={onClose} />}

      <div className={`w-80 flex-shrink-0 bg-white flex flex-col h-full border-r border-gray-200 md:relative md:flex fixed inset-y-0 left-0 z-40 transition-transform duration-200 ${isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`}>
        {/* Search bar */}
        <div className="px-3 py-2 bg-white">
          <div className="flex items-center bg-gray-100 rounded-full px-3 py-1.5 gap-2">
            <MagnifyingGlassIcon className="w-4 h-4 text-gray-400" />
            <input
              type="text"
              placeholder="Cari..."
              value={searchQuery}
              onChange={(e) => onSearch?.(e.target.value)}
              className="bg-transparent text-sm text-gray-700 placeholder-gray-400 outline-none flex-1"
            />
          </div>
        </div>

        {/* Items list */}
        <div className="flex-1 overflow-y-auto">
          {items.length === 0 ? (
            <p className="text-gray-400 text-sm text-center py-8 px-4">Tidak ada item</p>
          ) : (
            items.map((item) => (
              <div
                key={item.id}
                onClick={() => handleSelect(item)}
                className={`cursor-pointer px-3 py-3 border-b border-gray-100 hover:bg-gray-50 transition
                  ${selected?.id === item.id ? 'bg-green-50 border-l-4 border-wa-dark' : ''}`}
              >
                {renderItem ? renderItem(item) : (
                  <div className="min-w-0">
                    <p className="text-gray-800 text-sm truncate overflow-hidden">{item.title}</p>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}
